export default __webpack_public_path__ + "25db8cb.png";